import { Component, OnInit, OnDestroy, ViewEncapsulation, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { concat, merge, of, from, Subscription, Subject } from 'rxjs';
import { map, concatMap, switchMap, finalize } from 'rxjs/operators';
import { FilterService } from 'primeng/api';
import { Table } from 'primeng/table';

import { environment } from 'src/environments/environment';
import { Document } from 'src/app/shared/document';

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { DocumentApiService } from 'src/app/services/document-api.service';

@Component({
  selector: 'app-list-document-payments',
  templateUrl: './list-document-payments.component.html',
  styleUrls: ['./list-document-payments.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ListDocumentPaymentsComponent implements OnInit, OnDestroy, OnChanges {
  @Input() document: Document;

  globalSettinsData: GlobalSettingsData;

  recordsList: any[] = [];
  totalRecords: number = 0;

  selectedRecord: any;

  today: Date;

  totalPayd: number;
  totalCurrencyPayd: number;
  peaceOfCake: number;
  peaceOfCurrencyCake: number;

  loading: boolean = false;

  private recordsQuery: Subscription;

  @ViewChild('ptable1') ptable1: Table;

  cf1: any = {};    // to store f[string] filters value

  constructor(
    private docApi: DocumentApiService,
    private filterService: FilterService,
    private globalsettingsservice: GetglobalsettingsService,
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    console.log('*** ListDocumentPaymentsComponent ngOnChanges:');
    for (let propName in changes) {
      let change = changes[propName];

      switch (propName) {
        case 'clean':
          this.clearSavedSettings();

        case 'document':
          this.loadRecentOrdersData();
          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log("*** ListDocumentPaymentsComponent in ngOnDestroy");

    if (this.recordsQuery) { this.recordsQuery.unsubscribe(); }
  }

  ngOnInit(): void {
    console.log("*** ListDocumentPaymentsComponent in ngOnInit");

    this.today = new Date();

    console.log('*** Home in onInit: ' + JSON.stringify(this.today));

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();

    this.filterService.register('gtOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value > filter))
    )
    );

    this.filterService.register('GteOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value >= filter))
    )
    );

    this.loadRecentOrdersData();
  }


  /*
CURCODE: "CUSD            "
CURRATE: 1
DOCDATE: "2021-12-29T13:49:48.777Z"
DOCID: 95634
DOCITEM: 501080
DOCNAME: "Платежное поручение покупателя"
DOCSUM: 111121.56
DOCTYPE: 9
DOCVSUM: 111121.56
PAYDSUM: 53064.9
PAYDVSUM: 53064.9
PPART: 0.4775391922143642
PVPART: 0.4775391922143642
   */

  loadRecentOrdersData(): void {
    if (this.globalSettinsData) {
      this.loading = true;

      this.recordsQuery =
        this.docApi.getDocumentPaymentsList(this.document.DOCID, this.globalSettinsData.balanceCurrencyId, new Date())
          .pipe(
            concatMap(data => {
              this.recordsList = data || [];
              this.totalRecords = this.recordsList.length;

              environment.production || console.table(this.recordsList);
              return from(data);
            }),

            finalize(() => {

              this.totalPayd = this.recordsList.reduce((r, s) => r + s.PAYDSUM, 0);
              this.totalCurrencyPayd = this.recordsList.reduce((r, s) => r + s.PAYDVSUM, 0);

              this.peaceOfCake = this.recordsList.reduce((r, s) => r + s.PPART, 0);
              this.peaceOfCurrencyCake = this.recordsList.reduce((r, s) => r + s.PVPART, 0);

              this.loading = false;
            })
          )
          .subscribe();
    }
  }

  reloadTable(event) {
    console.log('*** ListDocumentPaymentsComponent reloadTable: ' + JSON.stringify(event));

    this.loadRecentOrdersData();
  }

  onChangeRecentOrdersType(event) {
    console.log('*** ListDocumentPaymentsComponent in onChangeRecentOrdersType');
    console.log(event);
    //    this.showProformaDocuments = event.checked;
    this.loadRecentOrdersData();
  }

  onRecentRowSelect(event) {
    //console.log('*** DocumentsComponent onRowSelect: ' + JSON.stringify(event.data))
  }

  onStateSave(state) {
    console.log('*** ListDocumentPaymentsComponent onStateSave: ' + JSON.stringify(state));
  }

  onStateRestoreNew(state) {
    console.log('*** ListDocumentPaymentsComponent onStateRestoreNew: ' + JSON.stringify(state));
    if (state.filters) {
      for (let f in state.filters) {
        let fltItem = state.filters[f];
        this.cf1[f] = Array.isArray(fltItem) ? fltItem[0].value : fltItem.value;
      }
    }
  }

  clearSavedSettings() {
    console.log('*** ListDocumentPaymentsComponent in clearSavedSettings: ');
    try {
      this.ptable1.clearState();
    } catch (e) {
      console.log('*** ListDocumentPaymentsComponent in clearSavedSettings: ' + JSON.stringify(e));
    }
  }
}
